<template>
  <div
    class="task-flex shadow cursor-pointer mb-2"
    @click="openTaskSidebar(task)"
  >
    <div class="task-flex-info flex-basis-10">
      <div class="mx-2">
        <span class="task-id">#{{ task.id }}</span>
      </div>
      <div
        :class="`task-tags tags-rounded-icon ${handlerStyleBackgroundTags(
          task
        )}`"
      ></div>
      <div class="task-tags-act ml-2">
        <span
          :class="`text-secondary`"
          v-html="handlerTypeReferenceId(task.reference_type_id)"
        ></span>
      </div>
    </div>
    <div class="px-2 flex-grow-1 my-2">
      <span class="font-size-16 text-brown">{{ task.title }}</span>
    </div>
    <div class="px-2 my-2">
      <div class="task-flex">
        <div
          v-for="realizator in task.realizators"
          :key="realizator.id"
          class="position-relative mr-2"
        >
          <template v-if="realizator.avatar_path">
            <img
              :id="`tooltip-${realizator.id}`"
              :src="realizator.avatar_path"
              class="mr-1"
              style="width: 25px; border-radius: 25px"
            />
          </template>
          <template v-else>
            <b-avatar
              :id="`tooltip-${realizator.id}`"
              :size="25"
              :text="nameAvatar(realizator.name)"
              class="mr-1"
            ></b-avatar>
          </template>
          <template v-if="realizator.id != currentUser.id">
            <div
              class="task-realizator-status"
              v-html="
                handlerRealizatorsColor(realizator.pivot.reference_status_id)
              "
            ></div>
          </template>
        </div>
      </div>
    </div>
    <div class="flex-basis-13 text-center my-2">
      <span>{{ task.realization_at | formattedDateTime }}</span>
    </div>
    <div class="pr-3 flex-basis-10 text-right my-2">
      <span
        :class="`task-tags-act ${statusColor}`"
        v-html="handlerTaskStatus(task.reference_status_id)"
      ></span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mixinTasks } from "@/mixins";
import { openTaskSidebar } from '@/mixins/openTaskSidebar';

export default {
  props: {
    task: { type: Object, default: () => ({}) },
  },
  mixins: [
    mixinTasks,
    openTaskSidebar
  ],
  computed: {
    ...mapGetters("auth", ["currentUser"]),
    statusColor() {
      const statusMapping = {
        400: "status-to-work",
        401: "status-on-work",
        402: "status-in-check",
        403: "status-done",
      };
      return statusMapping[this.task.reference_status_id];
    },
  },
  methods: {
    handlerRealizatorsColor(id) {
      if (id == "400") {
        return '<i class="fas fa-circle color-icon-to-work"></i>';
      }
      if (id == "401") {
        return '<i class="fas fa-circle color-icon-on-work"></i>';
      }
      if (id == "402") {
        return '<i class="fas fa-circle color-icon-in-check"></i>';
      }
      if (id == "403") {
        return '<i class="fas fa-circle color-icon-done"></i>';
      }
    },
    handlerTaskStatus(statusId) {
      if (statusId == 400) {
        return "К выполнению";
      }
      if (statusId == 401) {
        return "В работе";
      }
      if (statusId == 402) {
        return "На проверке";
      }
      if (statusId == 403) {
        return "Выполнено";
      }
    },
  },
};
</script>
